import { reactIcons as Icons } from '@project44/manifest-ds';
import { IShipmentSearchCriteria } from '@project44-models/shipment-list';

export const chatExamples: {
  message: string;
  isBot?: boolean;
  isInfo?: boolean;
  isHeader?: boolean;
  icon?: JSX.Element;
  filterCriteria?: IShipmentSearchCriteria;
  filterName?: string;
}[] = [
  {
    message: 'Examples',
    isHeader: true,
    icon: <Icons.CheckDouble css={{ color: '$palette-indigo-100' }} />,
  },
  {
    message: 'Ocean shipments that are running late to a west coast port',
    isInfo: true,
    filterName: 'Late Ocean Shipments',
    filterCriteria: {
      transportationModes: [
        {
          mode: ['OCEAN'],
          operator: 'EQUALS',
        },
      ],
      shipmentEvents: [
        {
          type: 'ARRIVAL_AT_STOP',
          deltas: [
            {
              type: 'RUNNING_LATE',
              value: 1440,
              operator: 'MORE_THAN',
            },
          ],
          stopProperties: [
            {
              propertyName: 'LOCATION_STATE',
              values: ['CA', 'OR', 'WA'],
              operator: 'EQUALS',
            },
            {
              propertyName: 'LOCATION_COUNTRY',
              values: ['US'],
              operator: 'EQUALS',
            },
          ],
          stopType: {
            types: ['PORT_OF_DISCHARGE'],
            operator: 'EQUALS',
          },
        },
      ],
    },
  },
  {
    message: 'Air shipment that departed late from Europe',
    isInfo: true,
    filterName: 'Late Air Shipments',
    filterCriteria: {
      transportationModes: [
        {
          mode: ['AIR'],
          operator: 'EQUALS',
        },
      ],
      shipmentEvents: [
        {
          type: 'DEPARTURE_FROM_STOP',
          stopProperties: [
            {
              propertyName: 'LOCATION_COUNTRY',
              values: [
                'AL',
                'AD',
                'AM',
                'AT',
                'AZ',
                'BY',
                'BE',
                'BA',
                'BG',
                'HR',
                'CY',
                'CZ',
                'DK',
                'EE',
                'FI',
                'FR',
                'GE',
                'DE',
                'GR',
                'HU',
                'IS',
                'IE',
                'IT',
                'KZ',
                'XK',
                'LV',
                'LI',
                'LT',
                'LU',
                'MT',
                'MD',
                'MC',
                'ME',
                'NL',
                'MK',
                'NO',
                'PL',
                'PT',
                'RO',
                'RU',
                'SM',
                'RS',
                'SK',
                'SI',
                'ES',
                'SE',
                'CH',
                'TR',
                'UA',
                'GB',
                'VA',
              ],
              operator: 'EQUALS',
            },
          ],
          deltas: [
            {
              type: 'OCCURRED_LATE',
              value: 1,
              operator: 'MORE_THAN',
            },
          ],
        },
      ],
    },
  },
  {
    message: 'TL shipments that are missing an equipment identifer',
    isInfo: true,
    filterName: 'TL without identifier',
    filterCriteria: {
      transportationModes: [
        {
          mode: ['TRUCKLOAD'],
          operator: 'EQUALS',
        },
      ],
      shipmentTrackingStatusEvents: [
        {
          types: ['MISSING_EQUIPMENT_IDENTIFIER'],
          operator: 'EQUALS',
        },
      ],
    },
  },
  {
    message: 'Capabilities',
    isHeader: true,
    icon: <Icons.InfoCircled css={{ color: '$palette-indigo-100' }} />,
  },
  {
    message: 'Applies filters and sort order based on your chat',
    isInfo: true,
  },
  {
    message:
      'Remembers what was said earlier in the conversation, allowing you to follow up and make corrections',
    isInfo: true,
  },
  { message: 'Trained to decline inappropriate requests', isInfo: true },
  {
    message: 'Limitations',
    isHeader: true,
    icon: <Icons.Warning css={{ color: '$palette-indigo-100' }} />,
  },
  {
    message:
      'May occasionally generate incorrect information about shipments, dates, or events',
    isInfo: true,
  },
  { message: 'Limited knowledge of world events after 2021', isInfo: true },
];
